module.exports = __webpack_public_path__ + "img/0_pintura.d13019fc.svg";